
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppFooter',

  computed: {
    currentYear(): number {
      return new Date().getFullYear();
    },

    footerLogo() {
      return this.$store.getters['Config/getFooterLogo'];
    },

    footerAddress() {
      return this.$store.getters['Config/getFooterAddress'].split(',');
    },

    legalBusinessName() {
      return this.$store.getters['Config/getLegalBusinessName'];
    },
  }
});
